// extracted by mini-css-extract-plugin
export var progressBar = "_j1-0";
export var progressBarInner = "_j1-1";